import { datadogRum, type RumInitConfiguration } from '@datadog/browser-rum';

const applicationId = import.meta.env.VITE_DATADOG_APPLICATION_ID;
const clientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN;

if (
  import.meta.env.VITE_ENV === 'production' &&
  applicationId &&
  clientToken
) {
  datadogRum.init({
    applicationId,
    clientToken,
    site: (import.meta.env.VITE_DATADOG_SITE ?? 'datadoghq.com') as RumInitConfiguration['site'],
    service: import.meta.env.VITE_DATADOG_SERVICE ?? 'flagsync-horizon',
    env: import.meta.env.VITE_DATADOG_ENV ?? 'prod',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}
